import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { ViewModelConnector } from '@mobilefirstdev/base-angular';
import { EditTemplateCardStackMenuViewModel } from '../edit-template-card-stack-menu-view-model';

@Component({
  selector: 'app-edit-template-card-stack-menu-footer',
  templateUrl: './edit-template-card-stack-menu-footer.component.html',
  styleUrls: [
    './edit-template-card-stack-menu-footer.component.scss',
    '../../../../../shared/styles/edit-page-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditTemplateCardStackMenuFooterComponent extends BaseComponent {
  constructor(public viewModel: EditTemplateCardStackMenuViewModel) {
    super();
  }

  @Input() formDisableSubmit: boolean = true;
  @Input() formErrorMessages: { [label: string]: string } | null | undefined;
  @Input() formHasErrors: boolean = true;
  @Input() formPristine: boolean = true;
  @Input() @ViewModelConnector('connectToFormAutoSubmitted') formAutoSubmitted: any[];
  @Output() submitForms = new EventEmitter<boolean>(true);
}
